import { render } from "./ResultItem.vue?vue&type=template&id=95eed840&scoped=true"
import script from "./ResultItem.vue?vue&type=script&lang=js"
export * from "./ResultItem.vue?vue&type=script&lang=js"

import "./ResultItem.vue?vue&type=style&index=0&id=95eed840&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95eed840"]])

export default __exports__